import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Income from '@/components/Income';
import Growth from '@/components/Growth';
import Calculator from '@/components/Calculator';

Vue.use(VueRouter)

  const routes = [


    {
      path: '/income',
      name: 'income',
      component: Income,
    }, {
      path: '/payment',
      name: 'payment',
      component: Growth,
    }, {
      path: '/calculator',
      name: 'calculator',
      component: Calculator,
    // }, {
    //   path: '/',
    //   component: Income,
    }, {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '*',
      redirect: '/'
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
